<div class="medicine-dosage-package-type-list">
  <div class="mbp-table-wrap">
    <table mat-table matSort [dataSource]="medicineDosagePackageTypes" class="mbp-data-table medicine-dosage-package-type-list__table">
      <ng-container matColumnDef="label_name">
        <th mat-header-cell *matHeaderCellDef>Label name</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">{{ medicineDosagePackageType.label_name ? medicineDosagePackageType.label_name : '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">{{ medicineDosagePackageType.package_type.type }}</td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>Quantity</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">{{ medicineDosagePackageType.contained_quantity }} {{ dosageUnit ? dosageUnit.unit : '' }}</td>
      </ng-container>

      <ng-container matColumnDef="units_per_pack">
        <th mat-header-cell *matHeaderCellDef>Units per pack</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">{{ medicineDosagePackageType.units_per_pack != null ? medicineDosagePackageType.units_per_pack : 1 }}</td>
      </ng-container>

      <ng-container matColumnDef="min_order_qty">
        <th mat-header-cell *matHeaderCellDef>Min qty</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">{{ medicineDosagePackageType.min_order_qty != null ? medicineDosagePackageType.min_order_qty : '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">{{ medicineDosagePackageType.price }}</td>
      </ng-container>

      <ng-container matColumnDef="sage_item_code">
        <th mat-header-cell *matHeaderCellDef>Sage item code</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType" class="sage-item-code-col">
          @if (isMissingSageItemCode(medicineDosagePackageType)) {
            <span class="sage-item-code-missing">{{ sageItemCodeMissingWarning }}</span>
          } @else {
            {{ sageItemCodeLabel(medicineDosagePackageType) }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType">{{ getCreationTime(medicineDosagePackageType) }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-col">&nbsp;</th>
        <td mat-cell *matCellDef="let medicineDosagePackageType" class="actions-col">
          <div class="medicine-dosage-package-type-list__actions">
            <button *authGroup="['SuperAdmin']" type="button" class="medicine-dosage-package-type-list__btn" (click)="edit(medicineDosagePackageType)" mat-stroked-button>
              <mat-icon>edit</mat-icon> Edit
            </button>
            <button *authGroup="['SuperAdmin']" type="button" mat-stroked-button class="medicine-dosage-package-type-list__btn medicine-dosage-package-type-list__btn--warn" (click)="delete(medicineDosagePackageType)">
              Delete
            </button>
            <button
              *authGroup="orderMedicineViewRoles"
              type="button"
              mat-stroked-button
              class="medicine-dosage-package-type-list__btn medicine-dosage-package-type-list__btn--order"
              [disabled]="isAddToOrderDisabled(medicineDosagePackageType)"
              [matTooltip]="addToOrderTooltip(medicineDosagePackageType)"
              matTooltipShowDelay="300"
              (click)="addToOrderSystem(medicineDosagePackageType)"
            >
              <mat-icon>add_shopping_cart</mat-icon>
              {{ isInOrderSystem(medicineDosagePackageType) ? 'In order system' : 'Add to order' }}
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <mat-paginator
    class="medicine-dosage-package-type-list__paginator"
    [length]="total"
    [pageSize]="limit"
    [pageIndex]="page - 1"
    [pageSizeOptions]="[5, 10, 20, 50]"
    (page)="onPageChange($event)">
  </mat-paginator>

  <div class="medicine-dosage-package-type-list__pager">
    <div class="medicine-dosage-package-type-list__pager-buttons">
      <button type="button" mat-stroked-button class="medicine-dosage-package-type-list__pager-btn" (click)="prevPage()" [disabled]="page <= 1">
        <mat-icon>chevron_left</mat-icon>
        Previous
      </button>
      <button type="button" mat-stroked-button class="medicine-dosage-package-type-list__pager-btn" (click)="nextPage()" [disabled]="(page * limit) >= total">
        Next
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    <span class="medicine-dosage-package-type-list__pager-label">Page {{ page }} of {{ lastPage }}</span>
  </div>
</div>
